
import { forOwn, postData } from "./utils";
import { _createStakeWsClient } from "./stake-ws";
import { User, ApiKey } from "../stores";
import { v4 as uuidv4 } from 'uuid';

const APIKey = ApiKey;

var Client_gqlws = null

/** Stake Mirros 
***
**Stake.bet | Stake.games | Staketr.com | Staketr2.com (2-5) | Stake.bz | Stake.jp | Stake.ac  | Stake.icu
**/

const WS_API = "https://api.stake.com/websockets"

const reqConfig = {
 // url: "/stake",
  url: "https://api.stake.com/graphql",
  headers: {
    "x-access-token": "",
  },
};


class ListFetcher {
  constructor(payload, gqlClient){
    this.gql = gqlClient
    this.payload = { query: payload.query,  variables: payload.variables || {} }

    this.results = []
    this.currPage = 0
    this.limit = 50
    this.offset = 0

    console.log("ListFetcher constructor, this.payload: ", this.payload)
  }

  async * nextPage (){
    let chunk

    do {
      this.payload.variables.offset = this.currPage*this.limit
      chunk = await this.gql.wsQuery(this.payload)
      this.results.push(chunk)
      this.currPage += 1

      yield chunk

    } while( !(chunk.data.user.transaction.length < this.limit) && (this.currPage*this.limit ) < 100 )

    return
  }
}

const fethTransactions = async (p) => {

  const listFetcher = new ListFetcher(p, Client_gqlws)
  let counter = 0
  let txList = []
  
  
  for await (let transactions of listFetcher.nextPage() ) {
    txList = txList.concat(transactions.data.user.transaction)
    // console.log(">> transactions ["+ (counter++) +"] : \n\t", transactions.data.user.transaction );
  }

   console.log(">> user "+ p.variables.name +" transactions ["+ (txList.length) +"]  : \n\t",  txList);

   return txList
}


console.log("fethTransactions ",  (n, t) =>  fethTransactions(createUserTransactionQuery(n, t)))


const APIQueries = {
  "games": {

    "limbo": {
      "bet": {
          "query":`
              mutation LimboBet($amount: Float!, $multiplierTarget: Float!, $currency: CurrencyEnum!, $identifier: String!) {
                limboBet(
                  amount: $amount
                  currency: $currency
                  multiplierTarget: $multiplierTarget
                  identifier: $identifier
                ) {
                  ...CasinoBet
                state {
                    ...CasinoGameLimbo
                }
                }
              }
              
              fragment CasinoBet on CasinoBet {
                id
                active
                payoutMultiplier
                amount
                payout
                updatedAt
                currency
                game
                
              }
              
              fragment CasinoGameLimbo on CasinoGameLimbo {
                result
                multiplierTarget
              }
          
          `,
          "variables": {
          "multiplierTarget": 2,
          "identifier": "",
          "amount": 0,
          "currency": "trx"
        }
      },
   
      "batch": {
        query: `
       mutation LimboBet($amount: Float!, $multiplierTarget: Float!, $currency: CurrencyEnum!, $identifier: String!){		

            Bet_1: limboBet(amount: $amount,    currency: $currency,	multiplierTarget: $multiplierTarget,	identifier: $identifier	) {
                      ... CasinoBet
                      state {
                        ... on CasinoGameLimbo {
                        result
                        multiplierTarget
                        }
                      }
                    }
          Bet_2: limboBet(amount: $amount,    currency: $currency,	multiplierTarget: $multiplierTarget,	identifier: $identifier	) {
                      ... CasinoBet
                      state {
                        ... on CasinoGameLimbo {
                        result
                        multiplierTarget
                        }
                      }
                    }
          Bet_3: limboBet(amount: $amount,    currency: $currency,	multiplierTarget: $multiplierTarget,	identifier: $identifier	) {
                ... CasinoBet 
                state {
                  ... on CasinoGameLimbo {
                  result
                  multiplierTarget
                  }
                }
              }
          Bet_4: limboBet(amount: $amount,    currency: $currency,	multiplierTarget: $multiplierTarget,	identifier: $identifier	) {
               ... CasinoBet 
                state {
                  ... on CasinoGameLimbo {
                  result
                  multiplierTarget
                  }
                }
              }
        }
         
         fragment CasinoBet on CasinoBet {
          id
          active
          payoutMultiplier
          amountMultiplier
          amount
          payout
          updatedAt
          currency
          game
          user {
          id
          name
          }
      }`,
        variables: {
          amount: 0,
          multiplierTarget: 2,
          currency: "ltc",
          identifier: "abc_" + Date.now()
        },
        //operationName: ""
      }
    },
     
    "wheel": {
      "bet": {
        query: `
          mutation WheelSpin($amount: Float!, $currency: CurrencyEnum!, $risk: CasinoGameWheelRiskEnum!, $segments: Int!, $identifier: String!) {
            wheelSpin(
              amount: $amount
              currency: $currency
              risk: $risk
              segments: $segments
              identifier: $identifier
            ) {
              ...CasinoBet
              state {
                ...CasinoGameWheel
              }
            }
          }
          
          fragment CasinoBet on CasinoBet {
            id
            payoutMultiplier
            amount
            payout
            updatedAt
            currency
            game
          }
          
          fragment CasinoGameWheel on CasinoGameWheel {
            result
            segments
            risk
          }
        `,
        
        variables: {
          "amount": 0,
          "currency": "trx",
          "risk": "high",
          "segments": 50,
          "identifier": ""
        }
      },
    },

    "dice": {
      "bet": {
        "query": "mutation DiceRoll($amount: Float!, $target: Float!, $condition: CasinoGameDiceConditionEnum!, $currency: CurrencyEnum!, $identifier: String!) {\n  diceRoll(\n    amount: $amount\n    target: $target\n    condition: $condition\n    currency: $currency\n    identifier: $identifier\n  ) {\n    ...CasinoBet\n    state {\n      ...CasinoGameDice\n    }\n  }\n}\n\nfragment CasinoBet on CasinoBet {\n  id\n  active\n  payoutMultiplier\n  amountMultiplier\n  amount\n  payout\n  updatedAt\n  currency\n  game\n  user {\n    id\n    name\n  }\n}\n\nfragment CasinoGameDice on CasinoGameDice {\n  result\n  target\n  condition\n}\n",
        "variables": {
          "target": 50.5,
          "condition": "above",
          "identifier": "",
          "amount": 0,
          "currency": "btc"
        }
      }
    },

    "mines": {
      "bet": {
        query: `mutation MinesBet($amount: Float!, $currency: CurrencyEnum!, $minesCount: Int!, $fields: [Int!], $identifier: String) {
          minesBet(
            amount: $amount
            currency: $currency
            minesCount: $minesCount
            fields: $fields
            identifier: $identifier
          ) {
            ...CasinoBet
            state {
              ...CasinoGameMines
            }
          }
        }
        
        fragment CasinoBet on CasinoBet {
          id
          active
          payoutMultiplier
          amount
          payout
          updatedAt
          currency
          game
        }
        
        fragment CasinoGameMines on CasinoGameMines {
          mines
          minesCount
          rounds {
            field
            payoutMultiplier
          }
        }
        `,
           variables: {
           amount: 0,
            currency: "btc",
            identifier: "mines_" + Date.now(),
            minesCount: 12, // 1-24
            fields: [] // 0..24
        }
      }
    },

    "diamonds": {
      "bet": {
        query: `
          mutation DiamondsBet($amount: Float!, $currency: CurrencyEnum!, $identifier: String) {
            diamondsBet(amount: $amount, currency: $currency, identifier: $identifier) {
              ...CasinoBet
              state {
                ...CasinoGameDiamonds
              }
            }
          }
          
          fragment CasinoBet on CasinoBet {
            id
            active
            payoutMultiplier
            amount
            payout
            updatedAt
            currency
            game
          }
          
          fragment CasinoGameDiamonds on CasinoGameDiamonds {
            hand
          }
        
        `,
          variables: {
          currency: "btc",
          amount: 0,
          identifier: ""
        }
      }


    },
    "dragontower": {
      "bet": {
        query: `
          mutation DragonTowerBet($amount: Float!, $currency: CurrencyEnum!, $difficulty: DragonTowerDifficultyEnum!, $eggs: [Int!]!, $identifier: String) {
            dragonTowerBet(
              amount: $amount
              currency: $currency
              difficulty: $difficulty
              eggs: $eggs
              identifier: $identifier
            ) {
              ...CasinoBet
              state {
                ...CasinoGameDragonTower
              }
            }
          }
          
          fragment CasinoBet on CasinoBet {
            id
            active
            payoutMultiplier
            amount
            payout
            currency
            game
          }
          
          fragment CasinoGameDragonTower on CasinoGameDragonTower {
            currentRound
            playedRounds
            difficulty
            rounds
            tilesSelected
          }
        
        `,
          variables: {
            "amount": 0,
            "currency": "ltc",
            "identifier":  "dt_"+ Date.now(),
            "difficulty": "easy",
            "eggs": []
        }
      }


    },
    "scarab": {
      "bet": {
        query: `
        mutation slotsBet($amount: Float!, $lines: Int!, $currency: CurrencyEnum!, $identifier: String!) {
          slotsBet(
            amount: $amount
            currency: $currency
            lines: $lines
            identifier: $identifier
          ) {
            ...CasinoBet
            state {
              ...SlotsStateFragment
            }
          }
        }
        
        fragment CasinoBet on CasinoBet {
          id
          active
          payoutMultiplier
          amount
          payout
          currency
          game
        }
        
        fragment SlotsStateFragment on CasinoGameSlots {
          lines
          rounds {
            scatterMultiplier
            roundMultiplier
            totalMultiplier
            bonusRemaining
            bonusTotal
          }
        }
        
        `,
          variables: {
            amount: 0,
            currency: "btc",
            identifier: "scar_" + Date.now(),
            lines: 1
        }
      }


    },
    "tomeoflife": {
      "bet": {
        query: `
        mutation tomeOfLifeBet($amount: Float!, $lines: Int!, $currency: CurrencyEnum!, $identifier: String!) {
          slotsTomeOfLifeBet(
            amount: $amount
            currency: $currency
            lines: $lines
            identifier: $identifier
          ) {
            ...CasinoBet
            state {
              ...SlotsStateFragment
            }
          }
        }
        
        fragment CasinoBet on CasinoBet {
          id
          active
          payoutMultiplier
          amount
          payout
          currency
          game
        }
        
        fragment SlotsStateFragment on CasinoGameSlotsTomeOfLife {
          lines
          rounds {
            scatterMultiplier
            roundMultiplier
            totalMultiplier
            bonusRemaining
            bonusTotal
          }
        }
        
        `,
          variables: {
            amount: 0,
            currency: "btc",
            identifier: "scar_" + Date.now(),
            lines: 1
        }
      }


    },

    "samurai": { 
      /** info - nextSpinType enum values
       *  bonus
       *  complete
       * regular
       * special 
       * */
       activeBet: {
        query: ` query SamuraiActiveBet {
                user {
                  id
                  activeCasinoBet(game: slotsSamurai) {                    
                    ...CasinoBet
                    state {
                      ...SamuraiSlotsStateFragment
                    }
                  }
                }
              }
              
              fragment CasinoBet on CasinoBet {
                id
                
                active
                payoutMultiplier
                amount
                payout
                updatedAt
                currency
                game
               
              }
              
              fragment SamuraiSlotsStateFragment on CasinoGameSlotsSamurai {
                nextSpinType
                bonusSpinsRemaining
                
              }
               `,
         variables: { }
      },
      bet: {
          query: `mutation slotsSamuraiBet($amount: Float!, $currency: CurrencyEnum!, $identifier: String) {
            slotsSamuraiBet(amount: $amount, currency: $currency, identifier: $identifier) {
              ...CasinoBet
              state {
                ...SamuraiSlotsStateFragment
              }
            }
          }
          
          fragment CasinoBet on CasinoBet {
            id
            active
            payoutMultiplier
            amount
            payout
            updatedAt
            currency
            game
           
          }
          
          fragment SamuraiSlotsStateFragment on CasinoGameSlotsSamurai {
            nextSpinType
            bonusSpinsRemaining
            
          }
          `,
          variables:{
            "currency": "btc",
            "amount": 0,
            "identifier": "samurai_"+ Date.now(),
        }

      },
      next: {
        query: `
          mutation slotsSamuraiNext($identifier: String){
            slotsSamuraiNext(identifier: $identifier) {
              ...CasinoBet
              state {
                ...SamuraiSlotsStateFragment
              }
            }
          }
          
          fragment CasinoBet on CasinoBet {
            id
            active
            payoutMultiplier
            amount
            payout
            updatedAt
            currency
            game
          }
          
          fragment SamuraiSlotsStateFragment on CasinoGameSlotsSamurai {
            nextSpinType
            bonusSpinsRemaining
            
          }
          
        `,
        variables: {
          identifier: "samurai_"+ Date.now()
        }
      }
    },
    "plinko": {
      "bet": {
        "query": `
          mutation PlinkoBet($amount: Float!, $currency: CurrencyEnum!, $risk: CasinoGamePlinkoRiskEnum!, $rows: Int!, $identifier: String!) {
            plinkoBet(
              amount: $amount
              currency: $currency
              risk: $risk
              rows: $rows
              identifier: $identifier
            ) {
              ...CasinoBet
              state {
                ...CasinoGamePlinko
              }
            }
          }
          
          fragment CasinoBet on CasinoBet {
            id
            active
            payoutMultiplier
            amount
            payout
            updatedAt
            currency
            game
          }
          
          fragment CasinoGamePlinko on CasinoGamePlinko {
            risk
            rows
            point
          }
        `,
         "variables": {
          "currency": "btc",
          "amount": 0,
          "rows": 12,
          "risk": "medium",
          "identifier": "plinko_" + Date.now(),
        }
      },
      "payouts": {
        "query": "query PlinkoPayouts {\n  info {\n    plinkoPayouts {\n      payouts\n      rows\n      risk\n    }\n  }\n}\n",
        "variables": {}
      }
    },
    "keno": {
      "bet": {
        query: `
          mutation KenoBet($amount: Float!, $currency: CurrencyEnum!, $numbers: [Int!]!, $identifier: String!, $risk: CasinoGameKenoRiskEnum) {
            kenoBet(
              amount: $amount
              currency: $currency
              numbers: $numbers
              risk: $risk
              identifier: $identifier
            ) {
              ...CasinoBet
              state {
                ...CasinoGameKeno
              }
            }
          }
          
          fragment CasinoBet on CasinoBet {
            id
            active
            payoutMultiplier
            amount
            payout
            currency
            game
          }
          
          fragment CasinoGameKeno on CasinoGameKeno {
            drawnNumbers
            selectedNumbers
            risk
          }
        `,
        variables: {
          currency: "btc",
          amount: 0,
          numbers: [],
          risk: "medium",
          identifier: "keno" + Date.now(),
        }
      },
      "payouts": {
        "query": "query KenoPayouts {\n  info {\n   kenoPayouts {\n      payouts\n       risk\n    }\n  }\n}\n",
        "variables": {}
      }
    },

    /****
     suits

     spades: "S"
     cross: "C"
     diamond: "D"
     hearts: "H"

     guess: "equal" || "lowerEqual" || "higherEqual"

    ****/
    "hilo": {
      activeBet: {
        query: ` query HiloActiveBet {
                user {
                  id
                  activeCasinoBet(game: hilo) {                    
                    ...CasinoBet
                    state {
                      ...CasinoGameHilo
                    }
                  }
                }
              }
              
              fragment CasinoBet on CasinoBet {
                id
                
                active
                payoutMultiplier
                amount
                payout
                updatedAt
                currency
                game
               
              }
              
              fragment CasinoGameHilo on CasinoGameHilo {
                startCard {
                  suit
                  rank
                }
                rounds {
                  card {
                    suit
                    rank
                  }
                  guess
                  payoutMultiplier
                }
          } `,
         variables: { }
      },

      bet: {
        "query": `
            mutation HiloBet($amount: Float!, $currency: CurrencyEnum!, $startCard: HiloBetStartCardInput!) {
              hiloBet(amount: $amount, currency: $currency, startCard: $startCard) {
                ...CasinoBet
                state {
                  ...CasinoGameHilo
                }
              }
            }
            
            fragment CasinoBet on CasinoBet {
              id
              active
              payoutMultiplier
              amount
              payout
              updatedAt
              currency
              game

            }
            
            fragment CasinoGameHilo on CasinoGameHilo {
              startCard {
                suit
                rank
              }
              rounds {
                card {
                  suit
                  rank
                }
                guess
                payoutMultiplier
              }
            }
        
        `,
        variables: {
            currency: "btc",
            amount: 0,
            startCard: {
                suit: "H",
                rank: "A"
            }
        }
      },

      next: {
        query: `
            mutation HiloNext($guess: CasinoGameHiloGuessEnum!) {
              hiloNext(guess: $guess) {
                ...CasinoBet
                state {
                  ...CasinoGameHilo
                }
              }
            }
            
            fragment CasinoBet on CasinoBet {
              id
              active
              payoutMultiplier
              amount
              payout
              updatedAt
              currency
              game
            }
            
            fragment CasinoGameHilo on CasinoGameHilo {
              startCard {
                suit
                rank
              }
              rounds {
                card {
                  suit
                  rank
                }
                guess
                payoutMultiplier
              }
            }        
        `,

        variables: { 
          guess: "higherEqual"
        }
      },
      cashout: {
        query: `
          mutation HiloCashout {
            hiloCashout {
              ...CasinoBet
              state {
                ...CasinoGameHilo
              }
            }
          }
          
          fragment CasinoBet on CasinoBet {
            id
            active
            payoutMultiplier
            amount
            payout
            updatedAt
            currency
            game
          }
          
          fragment CasinoGameHilo on CasinoGameHilo {
            startCard {
              suit
              rank
            }
            rounds {
              card {
                suit
                rank
              }
              guess
              payoutMultiplier
            }
          }
        
        `,
        variables: {}
      }
    },

    "videopoker": {
      activeBet: {
        query: `query VideoPokerActiveBet {
              user {
                id
                activeCasinoBet(game: videoPoker) {
                  ...CasinoBet
                  state {
                    ...CasinoGameVideoPoker
                  }
                }
              }
            }
            
            fragment CasinoBet on CasinoBet {
              id
              active
              payoutMultiplier
              amount
              payout
              updatedAt
              currency
              game             
            }
            
            fragment CasinoGameVideoPoker on CasinoGameVideoPoker {
              playerHand {
                suit
                rank
              }
              initialHand {
                suit
                rank
              }
              handResult
         }`,
         variables: { }
      },

      bet: {
        query: `
            mutation VideoPokerBet($amount: Float!, $currency: CurrencyEnum!) {
              videoPokerBet(amount: $amount, currency: $currency) {
                ...CasinoBet
                state {
                  ...CasinoGameVideoPoker
                }
              }
            }
            
            fragment CasinoBet on CasinoBet {
              id
              active
              payoutMultiplier
              amount
              payout
              updatedAt
              currency
              game              
            }
            
            fragment CasinoGameVideoPoker on CasinoGameVideoPoker {
              playerHand {
                suit
                rank
              }
              initialHand {
                suit
                rank
              }
              handResult
            }
                                
        `,
        variables: {
            currency: "btc",
            amount: 0            
        }
      },

      next: {
        query: `
          mutation VideoPokerNext($held: [VideoPokerNextHeldInput!]!, $identifier: String!) {
            videoPokerNext(held: $held, identifier: $identifier) {
              ...CasinoBet
              state {
                ...CasinoGameVideoPoker
              }
            }
          }
          
          fragment CasinoBet on CasinoBet {
            id
            active
            payoutMultiplier
            amount
            payout
            updatedAt
            currency
            game           
          }
          
          fragment CasinoGameVideoPoker on CasinoGameVideoPoker {
            playerHand {
              suit
              rank
            }
            initialHand {
              suit
              rank
            }
            handResult
          }
              
        `,
        
        // eg. { "suit": "H", "rank": "J" },
        variables:{
          identifier: "",
          held: []
        }
      }
    },


    /**games end */
  },

  /*** user related  */
  "user": {
    userData: { 
      query: `
        query UserData {
          user {
            id 
            name 
            balances {
              ...UserBalanceFragment
              __typename
            }
            __typename
          }
        }
        fragment UserBalanceFragment on UserBalance {
          available {
            amount
            currency
            __typename
          }
          vault {
            amount
            currency
            __typename
          }
        }      
     `,
      variables: { }
    },
    "transaction": { 
      query: `
      query Transaction($name: String, $types: [TransactionTypeEnum!], $offset: Int, $limit: Int) {
        user(name: $name) {
          id
          transaction(types: $types, limit: $limit, offset: $offset) {
            id
            type
            currency
            amount
            createdAt
            data {
              ... on ChatTip {
                id
                sender: sendBy {
                  id
                  name
                }
                receiver: user {
                  id
                  name
                }
              }
            }
          }
        }
      }
      
      `,
      variables: {name: "", limit: 50, offset: 0, types: []}
    },
    availableBalances: {
      query: `subscription AvailableBalances {
        availableBalances {
          amount
          identifier
          balance {
            amount
            currency
          }
        }
      }
      `,
      variables: {}
    },
    currenciesInfo: {
      query: `
      query rates {
        info {
            gold:  currency (currency: gold){
                 
                 eur: value(fiatCurrency: eur)
                  usd: value(fiatCurrency: usd)
                  btc: value(currency: btc)
          }
            sweeps:  currency (currency: sweeps){
                 
                 eur: value(fiatCurrency: eur)
                  usd: value(fiatCurrency: usd)
                  btc: value(currency: btc)
          }
            btc:  currency (currency: btc){
                 
                 eur: value(fiatCurrency: eur)
                  usd: value(fiatCurrency: usd)
                  btc: value(currency: btc)
          }
          bch: currency (currency: bch){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          bnb: currency (currency: bnb){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          doge: currency (currency: doge){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          eth: currency (currency: eth){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          ltc: currency (currency: ltc){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          xrp: currency (currency: xrp){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          trx: currency (currency: trx){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          eos: currency (currency: eos){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          usdt: currency (currency: usdt){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          usdc: currency (currency: usdc){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          busd: currency (currency: busd){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          dai: currency (currency: dai){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          ape: currency (currency: ape){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          cro: currency (currency: cro){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          link: currency (currency: link){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
      
          pol: currency (currency: pol){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
            sol: currency (currency: sol){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          sand: currency (currency: sand){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          shib: currency (currency: shib){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
          uni: currency (currency: uni){
              
              eur: value(fiatCurrency: eur)
              usd: value(fiatCurrency: usd)
              btc: value(currency: btc)
            }
        
          }
        }
      
      `,
      variables: {}
    },
    "myBetList": {
      query: "query MyBetList($offset: Int = 0, $limit: Int = 10, $game: BetHouseEnum, $name: String) {\n  user(name: $name) {\n    id\n    houseBetList(offset: $offset, limit: $limit, game: $game) {\n      ...BetFragment\n    }\n  }\n}\n\nfragment BetFragment on Bet {\n  id\n  iid\n  type\n  scope\n  game {\n    name\n    icon\n    slug\n  }\n  bet {\n    ... on CasinoBet {\n      ...CasinoBet\n      user {\n        id\n        name\n      }\n    }\n    ... on EvolutionBet {\n      ...EvolutionBet\n      user {\n        id\n        name\n      }\n    }\n    ... on MultiplayerCrashBet {\n      ...MultiplayerCrashBet\n      user {\n        id\n        name\n      }\n    }\n    ... on MultiplayerSlideBet {\n      ...MultiplayerSlideBet\n      user {\n        id\n        name\n      }\n    }\n    ... on SoftswissBet {\n      ...SoftswissBet\n      user {\n        id\n        name\n      }\n    }\n    ... on SportBet {\n      ...SportBet\n      user {\n        id\n        name\n      }\n    }\n    ... on PlayerPropBet {\n      ...PlayerPropBetFragment\n      user {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment CasinoBet on CasinoBet {\n  id\n  active\n  payoutMultiplier\n  amountMultiplier\n  amount\n  payout\n  updatedAt\n  currency\n  game\n  user {\n    id\n    name\n  }\n}\n\nfragment EvolutionBet on EvolutionBet {\n  id\n  amount\n  currency\n  createdAt\n  payout\n  payoutMultiplier\n  user {\n    id\n    name\n  }\n  softswissGame: game {\n    id\n    name\n    edge\n  }\n}\n\nfragment MultiplayerCrashBet on MultiplayerCrashBet {\n  id\n  user {\n    id\n    name\n  }\n  payoutMultiplier\n  gameId\n  amount\n  payout\n  currency\n  result\n  updatedAt\n  cashoutAt\n  btcAmount: amount(currency: btc)\n}\n\nfragment MultiplayerSlideBet on MultiplayerSlideBet {\n  id\n  user {\n    id\n    name\n  }\n  payoutMultiplier\n  gameId\n  amount\n  payout\n  currency\n  slideResult: result\n  updatedAt\n  cashoutAt\n  btcAmount: amount(currency: btc)\n  active\n  createdAt\n}\n\nfragment SoftswissBet on SoftswissBet {\n  id\n  amount\n  currency\n  updatedAt\n  payout\n  payoutMultiplier\n  user {\n    id\n    name\n  }\n  softswissGame: game {\n    id\n    name\n    edge\n    extId\n    provider {\n      id\n      name\n    }\n  }\n}\n\nfragment SportBet on SportBet {\n  id\n  amount\n  active\n  currency\n  status\n  payoutMultiplier\n  cashoutMultiplier\n  updatedAt\n  payout\n  createdAt\n  potentialMultiplier\n  adjustments {\n    id\n    payoutMultiplier\n    updatedAt\n    createdAt\n  }\n  user {\n    id\n    name\n  }\n  bet {\n    iid\n  }\n  outcomes {\n    odds\n    status\n    outcome {\n      ...SportMarketOutcome\n    }\n    market {\n      ...SportMarket\n    }\n    fixture {\n      id\n      status\n      slug\n      marketCount(status: [active, suspended])\n      extId\n      data {\n        ...SportFixtureDataMatch\n        ...SportFixtureDataOutright\n      }\n      tournament {\n        ...TournamentTreeNested\n      }\n      eventStatus {\n        ...SportFixtureEventStatus\n      }\n      betradarStream {\n        exists\n      }\n      abiosStream {\n        exists\n        stream {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment SportMarketOutcome on SportMarketOutcome {\n  active\n  id\n  odds\n  name\n}\n\nfragment SportMarket on SportMarket {\n  id\n  name\n  status\n  extId\n  specifiers\n}\n\nfragment SportFixtureDataMatch on SportFixtureDataMatch {\n  startTime\n  competitors {\n    ...SportFixtureCompetitor\n  }\n  __typename\n}\n\nfragment SportFixtureCompetitor on SportFixtureCompetitor {\n  name\n  extId\n  countryCode\n  abbreviation\n}\n\nfragment SportFixtureDataOutright on SportFixtureDataOutright {\n  name\n  startTime\n  endTime\n  __typename\n}\n\nfragment TournamentTreeNested on SportTournament {\n  id\n  name\n  slug\n  category {\n    ...CategoryTreeNested\n  }\n}\n\nfragment CategoryTreeNested on SportCategory {\n  id\n  name\n  slug\n  sport {\n    id\n    name\n    slug\n  }\n}\n\nfragment SportFixtureEventStatus on SportFixtureEventStatus {\n  homeScore\n  awayScore\n  matchStatus\n  clock {\n    matchTime\n    remainingTime\n  }\n  periodScores {\n    homeScore\n    awayScore\n    matchStatus\n  }\n  currentServer {\n    extId\n  }\n  homeGameScore\n  awayGameScore\n  statistic {\n    yellowCards {\n      away\n      home\n    }\n    redCards {\n      away\n      home\n    }\n    corners {\n      home\n      away\n    }\n  }\n}\n\nfragment PlayerPropBetFragment on PlayerPropBet {\n  __typename\n  active\n  amount\n  cashoutMultiplier\n  createdAt\n  currency\n  id\n  odds\n  payout\n  payoutMultiplier\n  updatedAt\n  status\n  playerProps {\n    id\n    lineType\n    playerProp {\n      ...PlayerPropLineFragment\n    }\n  }\n  user {\n    id\n    name\n  }\n  playerProps {\n    id\n    lineType\n    playerProp {\n      ...PlayerPropLineFragment\n    }\n  }\n}\n\nfragment PlayerPropLineFragment on PlayerPropLine {\n  id\n  line\n  over\n  under\n  suspended\n  balanced\n  name\n  player {\n    id\n    name\n  }\n  market {\n    id\n    stat {\n      name\n      value\n    }\n    game {\n      id\n      fixture {\n        id\n        name\n        status\n        data {\n          ... on SportFixtureDataMatch {\n            __typename\n            startTime\n            competitors {\n              ...CompetitorFragment\n            }\n          }\n        }\n        tournament {\n          id\n          category {\n            id\n            sport {\n              id\n              name\n              slug\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment CompetitorFragment on SportFixtureCompetitor {\n  name\n  extId\n  countryCode\n  abbreviation\n}\n",
      variables: {
        limit: 50
      }
    },

    "createWithdrawalMeta": {
      query: "query CreateWithdrawalMeta {\n  user {\n    id\n    hasTfaEnabled\n    balances {\n      ...UserBalanceFragment\n      __typename\n    }\n    __typename\n  }\n  info {\n    currencies {\n      name\n      withdrawalFee {\n        value\n        __typename\n      }\n      withdrawalMin {\n        value\n        __typename\n      }\n      __typename\n    }\n    __typename\n  }\n}\n\nfragment UserBalanceFragment on UserBalance {\n  available {\n    amount\n    currency\n    __typename\n  }\n  vault {\n    amount\n    currency\n    __typename\n  }\n}\n",
      operationName: "CreateWithdrawalMeta",
      variables: {}
    },


  },
  /* user end */

  /* bets */
  "bets": {
    "betLookup": {
      query: "query BetLookup($iid: String, $betId: String) {\n  bet(iid: $iid, betId: $betId) {\n    ...BetFragment\n    __typename\n  }\n}\n\nfragment BetFragment on Bet {\n  id\n  iid\n  type\n  scope\n  game {\n    name\n    icon\n    slug\n    __typename\n  }\n  bet {\n    ... on CasinoBet {\n      ...CasinoBet\n      user {\n        id\n        name\n        __typename\n      }\n      __typename\n    }\n    ... on EvolutionBet {\n      ...EvolutionBet\n      user {\n        id\n        name\n        __typename\n      }\n      __typename\n    }\n    ... on MultiplayerCrashBet {\n      ...MultiplayerCrashBet\n      user {\n        id\n        name\n        __typename\n      }\n      __typename\n    }\n    ... on MultiplayerSlideBet {\n      ...MultiplayerSlideBet\n      user {\n        id\n        name\n        __typename\n      }\n      __typename\n    }\n    ... on SoftswissBet {\n      ...SoftswissBet\n      user {\n        id\n        name\n        __typename\n      }\n      __typename\n    }\n    ... on SportBet {\n      ...SportBet\n      user {\n        id\n        name\n        __typename\n      }\n      __typename\n    }\n    ... on PlayerPropBet {\n      ...PlayerPropBetFragment\n      user {\n        id\n        name\n        __typename\n      }\n      __typename\n    }\n    __typename\n  }\n}\n\nfragment CasinoBet on CasinoBet {\n  id\n  active\n  payoutMultiplier\n  amountMultiplier\n  amount\n  payout\n  updatedAt\n  currency\n  game\n  user {\n    id\n    name\n    __typename\n  }\n}\n\nfragment EvolutionBet on EvolutionBet {\n  id\n  amount\n  currency\n  createdAt\n  payout\n  payoutMultiplier\n  user {\n    id\n    name\n    __typename\n  }\n  softswissGame: game {\n    id\n    name\n    edge\n    __typename\n  }\n}\n\nfragment MultiplayerCrashBet on MultiplayerCrashBet {\n  id\n  user {\n    id\n    name\n    __typename\n  }\n  payoutMultiplier\n  gameId\n  amount\n  payout\n  currency\n  result\n  updatedAt\n  cashoutAt\n  btcAmount: amount(currency: btc)\n}\n\nfragment MultiplayerSlideBet on MultiplayerSlideBet {\n  id\n  user {\n    id\n    name\n    __typename\n  }\n  payoutMultiplier\n  gameId\n  amount\n  payout\n  currency\n  slideResult: result\n  updatedAt\n  cashoutAt\n  btcAmount: amount(currency: btc)\n  active\n  createdAt\n}\n\nfragment SoftswissBet on SoftswissBet {\n  id\n  amount\n  currency\n  updatedAt\n  payout\n  payoutMultiplier\n  user {\n    id\n    name\n    __typename\n  }\n  softswissGame: game {\n    id\n    name\n    edge\n    extId\n    provider {\n      id\n      name\n      __typename\n    }\n    __typename\n  }\n}\n\nfragment SportBet on SportBet {\n  id\n  amount\n  active\n  currency\n  status\n  payoutMultiplier\n  cashoutMultiplier\n  updatedAt\n  payout\n  createdAt\n  potentialMultiplier\n  adjustments {\n    id\n    payoutMultiplier\n    updatedAt\n    createdAt\n    __typename\n  }\n  user {\n    id\n    name\n    __typename\n  }\n  bet {\n    iid\n    __typename\n  }\n  outcomes {\n    odds\n    status\n    outcome {\n      ...SportMarketOutcome\n      __typename\n    }\n    market {\n      ...SportMarket\n      __typename\n    }\n    fixture {\n      id\n      status\n      slug\n      marketCount(status: [active, suspended])\n      extId\n      data {\n        ...SportFixtureDataMatch\n        ...SportFixtureDataOutright\n        __typename\n      }\n      tournament {\n        ...TournamentTreeNested\n        __typename\n      }\n      eventStatus {\n        ...SportFixtureEventStatus\n        __typename\n      }\n      betradarStream {\n        exists\n        __typename\n      }\n      abiosStream {\n        exists\n        stream {\n          id\n          __typename\n        }\n        __typename\n      }\n      __typename\n    }\n    __typename\n  }\n}\n\nfragment SportMarketOutcome on SportMarketOutcome {\n  active\n  id\n  odds\n  name\n}\n\nfragment SportMarket on SportMarket {\n  id\n  name\n  status\n  extId\n  specifiers\n}\n\nfragment SportFixtureDataMatch on SportFixtureDataMatch {\n  startTime\n  competitors {\n    ...SportFixtureCompetitor\n    __typename\n  }\n  __typename\n}\n\nfragment SportFixtureCompetitor on SportFixtureCompetitor {\n  name\n  extId\n  countryCode\n  abbreviation\n}\n\nfragment SportFixtureDataOutright on SportFixtureDataOutright {\n  name\n  startTime\n  endTime\n  __typename\n}\n\nfragment TournamentTreeNested on SportTournament {\n  id\n  name\n  slug\n  category {\n    ...CategoryTreeNested\n    __typename\n  }\n}\n\nfragment CategoryTreeNested on SportCategory {\n  id\n  name\n  slug\n  sport {\n    id\n    name\n    slug\n    __typename\n  }\n}\n\nfragment SportFixtureEventStatus on SportFixtureEventStatus {\n  homeScore\n  awayScore\n  matchStatus\n  clock {\n    matchTime\n    remainingTime\n    __typename\n  }\n  periodScores {\n    homeScore\n    awayScore\n    matchStatus\n    __typename\n  }\n  currentServer {\n    extId\n    __typename\n  }\n  homeGameScore\n  awayGameScore\n  statistic {\n    yellowCards {\n      away\n      home\n      __typename\n    }\n    redCards {\n      away\n      home\n      __typename\n    }\n    corners {\n      home\n      away\n      __typename\n    }\n    __typename\n  }\n}\n\nfragment PlayerPropBetFragment on PlayerPropBet {\n  __typename\n  active\n  amount\n  cashoutMultiplier\n  createdAt\n  currency\n  id\n  odds\n  payout\n  payoutMultiplier\n  updatedAt\n  status\n  playerProps {\n    id\n    lineType\n    playerProp {\n      ...PlayerPropLineFragment\n      __typename\n    }\n    __typename\n  }\n  user {\n    id\n    name\n    __typename\n  }\n  playerProps {\n    id\n    lineType\n    playerProp {\n      ...PlayerPropLineFragment\n      __typename\n    }\n    __typename\n  }\n}\n\nfragment PlayerPropLineFragment on PlayerPropLine {\n  id\n  line\n  over\n  under\n  suspended\n  balanced\n  name\n  player {\n    id\n    name\n    __typename\n  }\n  market {\n    id\n    stat {\n      name\n      value\n      __typename\n    }\n    game {\n      id\n      fixture {\n        id\n        name\n        status\n        data {\n          ... on SportFixtureDataMatch {\n            __typename\n            startTime\n            competitors {\n              ...CompetitorFragment\n              __typename\n            }\n          }\n          __typename\n        }\n        tournament {\n          id\n          category {\n            id\n            sport {\n              id\n              name\n              slug\n              __typename\n            }\n            __typename\n          }\n          __typename\n        }\n        __typename\n      }\n      __typename\n    }\n    __typename\n  }\n}\n\nfragment CompetitorFragment on SportFixtureCompetitor {\n  name\n  extId\n  countryCode\n  abbreviation\n}\n",
      operationName: "BetLookup",
      variables: {
        /*
        "betId": "",
        "iid": ""
        */
      }
    },
    houseBets: {
      limbo: {
        query: `
            subscription HouseBets {
                houseBets {
                    ...RealtimeHouseBet
                    __typename
                }
            }

            fragment RealtimeHouseBet on Bet {
                id
                iid
                game {
                    name
                }
                bet {
                    __typename
                    ... on CasinoBet {
                        id
                        payoutMultiplier
                        amountMultiplier
                        amount
                        payout
                        
                        updatedAt
                        currency
                        state {
                    
                              ... on CasinoGameLimbo { 
                                    result
                                    multiplierTarget
                                }
                            
                        }
                        __typename
                    }	
                            
                }
              
            }
        `,
        variables: { }
      },
      wheel: {
        query: `
            subscription HouseBets {
                houseBets {
                    ...RealtimeHouseBet
                    __typename
                }
            }

            fragment RealtimeHouseBet on Bet {
                id
                iid
                game {
                    name
                }
                bet {
                    __typename
                    ... on CasinoBet {
                        id
                        payoutMultiplier
                        amountMultiplier
                        amount
                        payout
                        
                        updatedAt
                        currency
                        state {
                    
                              ... on CasinoGameWheel {
                                result
                                segments
                                risk
                              }
                            
                        }
                        __typename
                    }	
                            
                }
              
            }

    
        `,
        variables: { }
      },
      keno: {
        query: `
            subscription HouseBets {
                houseBets {
                    ...RealtimeHouseBet
                    __typename
                }
            }

            fragment RealtimeHouseBet on Bet {
                id
                iid
                game {
                    name
                }
                bet {
                    __typename
                    ... on CasinoBet {
                        id
                        payoutMultiplier
                        amountMultiplier
                        amount
                        payout
                        currency
                        state {
                    
                          ... on CasinoGameKeno {
                            drawnNumbers
                            selectedNumbers
                            risk
                          }
                            
                        }
                        __typename
                    }	
                            
                }
              
            }
        `,
        variables: { }
      },
      mines: {
        query: `
            subscription HouseBets {
                houseBets {
                    ...RealtimeHouseBet
                    __typename
                }
            }

            fragment RealtimeHouseBet on Bet {
                id
                iid
                game {
                    name
                }
                bet {
                    __typename
                    ... on CasinoBet {
                        id
                        payoutMultiplier
                        amountMultiplier
                        amount
                        payout
                        currency
                        state {
                    
                          ... on CasinoGameMines {
                            mines
                            minesCount
                            rounds { 
                              field
                              payoutMultiplier
                            }
                          }
                            
                        }
                        __typename
                    }	
                            
                }
              
            }
        `,
        variables: { }
      },

      diamonds: {
          query: `
              subscription HouseBets {
                  houseBets {
                      ...RealtimeHouseBet
                      __typename
                  }
              }
      
              fragment RealtimeHouseBet on Bet {
                  id
                  iid
                  game {
                      name
                  }
                  bet {
                      __typename
                      ... on CasinoBet {
                          id
                          active
                          payoutMultiplier
                          amountMultiplier
                          amount
                          payout

                          currency
                          state {
                      
                              ... on  CasinoGameDiamonds {  hand }
          
                              
                          }
                          __typename
                      }	
                              
                  }
                
              }
          `,
          variables: { }
      },
      videopoker: {
          query: `
              subscription HouseBets {
                  houseBets {
                      ...RealtimeHouseBet
                      __typename
                  }
              }
      
              fragment RealtimeHouseBet on Bet {
                  id
                  iid
                  game {
                      name
                  }
                  bet {
                      __typename
                      ... on CasinoBet {
                          id
                          active
                          payoutMultiplier
                          amount
                          payout
                          currency
                          state {                      
                              ... on  CasinoGameVideoPoker {  
                                  playerHand {
                                    suit
                                    rank
                                  }
                                  initialHand {
                                    suit
                                    rank
                                  }
                                  handResult
                               }    
                          }
                          __typename
                      }	
                              
                  }
                
              }
          `,
          variables: { }
      },
      hilo: {
          query: `
              subscription HouseBets {
                  houseBets {
                      ...RealtimeHouseBet
                      __typename
                  }
              }
      
              fragment RealtimeHouseBet on Bet {
                  id
                  iid
                  game {
                      name
                  }
                  bet {
                      __typename
                      ... on CasinoBet {
                          id
                          active
                          payoutMultiplier
                          amount
                          payout
                          currency
                          state {                      
                              ... on  CasinoGameHilo {  
                                  startCard {
                                    suit
                                    rank
                                  }
                                  rounds {
                                    card {
                                      suit
                                      rank
                                    }
                                    guess
                                    payoutMultiplier
                                  }
                               }                                        
                          }
                          __typename
                      }	
                              
                  }
                
              }
          `,
          variables: { }
      },
      plinko: {
          query: `
              subscription HouseBets {
                  houseBets {
                      ...RealtimeHouseBet
                      __typename
                  }
              }
      
              fragment RealtimeHouseBet on Bet {
                  id
                  iid
                  game {
                      name
                  }
                  bet {
                      __typename
                      ... on CasinoBet {
                          id
                          active
                          payoutMultiplier
                          amountMultiplier
                          amount
                          payout
                          currency
                          state {
                      
                            ... on CasinoGamePlinko {
                              rows
                              risk
                           }
                              
                          }
                          __typename
                      }	
                              
                  }
                
              }
          `,
          variables: { }
      },
      packs: {
          query: `
              subscription HouseBets {
                  houseBets {
                      ...RealtimeHouseBet
                      __typename
                  }
              }
      
              fragment RealtimeHouseBet on Bet {
                  id
                  iid
                  game {
                      name
                  }
                  bet {
                      __typename
                      ... on CasinoBet {
                          id
                          active
                          payoutMultiplier
                          amountMultiplier
                          amount
                          payout
                          currency
                          state {
                      
                            ... on CasinoGamePacks {
                              cards {
                                id
                                multiplier
                              }
                           }
                            __typename
                          }
                          __typename
                      }	
                              
                  }
                
              }
          `,
          variables: { }
      },
      dice: {
          query: `
              subscription HouseBets {
                  houseBets {
                      ...RealtimeHouseBet
                      __typename
                  }
              }
      
              fragment RealtimeHouseBet on Bet {
                  id
                  iid
                  game {
                      name
                  }
                  bet {
                      __typename
                      ... on CasinoBet {
                          id
                          active
                          payoutMultiplier
                          amountMultiplier
                          amount
                          payout
                          
                          updatedAt
                          currency
                          state {
                      
                            ... on CasinoGameDice { 
                              result
                              target
                              condition
                          }
                              
                          }
                          __typename
                      }	
                              
                  }
                
              }
          `,
          variables: { }
      },
      dragontower: {
          query: `
              subscription HouseBets {
                  houseBets {
                      ...RealtimeHouseBet
                      __typename
                  }
              }
      
              fragment RealtimeHouseBet on Bet {
                  id
                  iid
                  game {
                      name
                  }
                  bet {
                      __typename
                      ... on CasinoBet {
                          id
                          active
                          payoutMultiplier
                          amount
                          payout
                          
                          updatedAt
                          currency
                          state {
                      
                            ... on CasinoGameDragonTower {
                              currentRound
                              playedRounds
                              difficulty
                              rounds
                              tilesSelected
                            }
                              
                          }
                          __typename
                      }	
                              
                  }
                
              }
          `,
          variables: { }
      },
      scarab: {
          query: `
              subscription HouseBets {
                  houseBets {
                      ...RealtimeHouseBet
                      __typename
                  }
              }
      
              fragment RealtimeHouseBet on Bet {
                  id
                  iid
                  game {
                      name
                  }
                  bet {
                      __typename
                      ... on CasinoBet {
                          id
                          active
                          payoutMultiplier
                          amountMultiplier
                          amount
                          payout
                          
                          updatedAt
                          currency
                          state {
                      
                             
                          ... on CasinoGameSlots {
                            lines
                            rounds {
                              scatterMultiplier
                              roundMultiplier
                              totalMultiplier
                              bonusRemaining
                              bonusTotal
                            }
                          }
                              
                          }
                          __typename
                      }	
                              
                  }
                
              }
          `,
          variables: { }
      },
      tomeoflife: {
          query: `
              subscription HouseBets {
                  houseBets {
                      ...RealtimeHouseBet
                      __typename
                  }
              }
      
              fragment RealtimeHouseBet on Bet {
                  id
                  iid
                  game {
                      name
                  }
                  bet {
                      __typename
                      ... on CasinoBet {
                          id
                          active
                          payoutMultiplier
                          amountMultiplier
                          amount
                          payout
                          
                          updatedAt
                          currency
                          state {
                      
                             
                          ... on CasinoGameSlotsTomeOfLife {
                            lines
                            rounds {
                              scatterMultiplier
                              roundMultiplier
                              totalMultiplier
                              bonusRemaining
                              bonusTotal
                            }
                          }
                              
                          }
                          __typename
                      }	
                              
                  }
                
              }
          `,
          variables: { }
      },
      samurai: {
          query: `
              subscription HouseBets {
                  houseBets {
                      ...RealtimeHouseBet
                      __typename
                  }
              }
      
              fragment RealtimeHouseBet on Bet {
                  id
                  iid
                  game {
                      name
                  }
                  bet {
                      __typename
                      ... on CasinoBet {
                          id
                          active
                          payoutMultiplier
                          amountMultiplier
                          amount
                          payout
                          
                          updatedAt
                          currency
                          state {
                      
                             
                          ... on CasinoGameSlotsSamurai {
                            nextSpinType
                            bonusSpinsRemaining
                            
                          }
                              
                        }
                          __typename
                     }	
                              
                   }
                
              }
          `,
          variables: { }
      },
    
    }

  },

  chat: { 
    roomIds: {
      de: {
         chatId: "94e807f3-a2fc-4caf-b0ff-ccc613f71879"
      },
      en: {
        chatId: "f0326994-ee9e-411c-8439-b4997c187b95"
      },
      challenges: {
        chatId: "5d43c7fb-e444-4b0d-aa5e-1e78becd86eb"
      }
    },
    sendMessage: {
        query: `mutation SendMessage($chatId: String!, $message: String!) {
          sendMessage(chatId: $chatId, message: $message) {
            id
            __typename
          }
        }
        `,
        variables: {
          "chatId": "ab",
          "message": ""
      }
    },

    /* 
     subscription ChatMessages($chatId: String!) {
        chatMessages(chatId: $chatId) {
          ...ChatMessage
          __typename
        }
      }


      data {
          ... on ChatMessageDataBot {
            message
            __typename
          }
          ... on ChatMessageDataTip {
            tip {
              id
              amount
              currency
              sender: sendBy {
                ...UserTags
                __typename
              }
              receiver: user {
                ...UserTags
                __typename
              }
              __typename
            }
            __typename
          }
          ... on ChatMessageDataRain {
            rain {
              amount
              currency
              rainUsers {
                user {
                  id
                  name
                  __typename
                }
                __typename
              }
              giver: user {
                ...UserTags
                __typename
              }
              __typename
            }
            __typename
          }
      }
    */

    chatMessages: {
      query: `
      subscription ChatMessages($chatId: String!) {
        chatMessages(chatId: $chatId) {
          ...ChatMessage
        }
      }
      
      fragment ChatMessage on ChatMessage {
        id
        data {

       
          ... on ChatMessageDataText {
            message

          }
     
          ... on ChatMessageDataRain {
            rain {
              amount
              currency
              rainUsers {
                user {
                  id
                  name
                 
                }
                
              }
              giver: user {
                ...UserTags
                
              }
              
            }
            __typename
          }

        }
        createdAt
        user {
          ...UserTags
        }
      }

      
      fragment UserTags on User {
        id
        name
        roles {
          name
        }

      }
      
      `,
      variables: {
        chatId: ""
      }
    },
    eddieCheck: {
      query: `
      subscription s($chatId: String!) {
        chatMessages(chatId: $chatId) {
          ...ChatMessage
        }
      }
      
      fragment ChatMessage on ChatMessage {        
        data {

          ... on ChatMessageDataRain {
            rain {
              amount
              currency             
              
              giver: user {
                ...UserTags
                
              }
              
            }           
          }          
        
         }

      }

      
      fragment UserTags on User {
        id
        name
      

      }
      
      `,
      variables: {
        chatId: ""
      }
    },
  },
}

function createBetQuery(game, variables = {}) {
  let _vars = { ...APIQueries.games[game].bet.variables }

  forOwn(_vars, (val, key, obj) => {
    if (Object.hasOwn(variables, key))
      _vars[key] = variables[key]
  })

  return {
    "query": APIQueries.games[game].bet.query,
    "variables": { ..._vars, ... { identifier: uuidv4() } }
  }

}

function createStageBetQuery(game, variables = {}) {

  let queryCollection = { }
  forOwn(APIQueries.games[game], (queryObj,queryKey,obj) => {
    let _vars = { ... queryObj.variables }

    forOwn(_vars, (val, key, obj) => {
      if (Object.hasOwn(variables, key))
        _vars[key] = variables[key]
      else if(key == 'identifier')
        _vars[key] = uuidv4()
    })

    queryCollection[queryKey] = {
      "query": queryObj.query,
      "variables": { ..._vars }
    }

  })
  /*
  let _vars = { ...APIQueries.games[game].bet.variables }

  forOwn(_vars, (val, key, obj) => {
    if (Object.hasOwn(variables, key))
      _vars[key] = variables[key]
  })

  return {
    "query": APIQueries.games[game].bet.query,
    "variables": { ..._vars, ... { identifier: uuidv4() } }
  }
*/

  return queryCollection
}

function createBatchBetQuery(game, variables = {}) {
  let _vars = { ...APIQueries.games[game].bet.variables }

  forOwn(_vars, (val, key, obj) => {
    if (Object.hasOwn(variables, key))
      _vars[key] = variables[key]
  })

  return {
    "query": APIQueries.games[game].batch.query,
    "variables": { ..._vars, ... { identifier: uuidv4() } }
  }

}

function createActiveBetQuery(game) {
  return {
    ... APIQueries.games[game].activeBet
  }
}

function createUserDataQuery() {
  return {
    ... APIQueries.user.userData
  }
}

function createCurrenciesInfoQuery() {
  return {
    ... APIQueries.user.currenciesInfo
  }
}

function createUserTransactionQuery(name, types) {
  return {
   query:  APIQueries.user.transaction.query,
   variables: { ...APIQueries.user.transaction.variables, ... {  name, types: types }  }
  }
}

function createUserBalancesQuery() {
  return {
    ... APIQueries.user.availableBalances
  }
}

function createMyBetListQuery(limit = 10, offset, game, name) {
  return {
    "query": APIQueries.user.myBetList.query,
    "variables": { ...APIQueries.user.myBetList.variables, ... { limit, offset, game, name } }
  }
}

function BetLookupByIdQuery(betId = "") {
  return {
    "query": APIQueries.bets.betLookup.query,
    "variables": { ...APIQueries.bets.betLookup.variables, ... { betId } }
  }
}
function ChatMessagesQuery(room = "de") {

  return {
    "query": APIQueries.chat.chatMessages.query,
    "variables": { ...APIQueries.chat.chatMessages.variables, ...  APIQueries.chat.roomIds[room]  }
  }
}
function ChatEddieCheckQuery(room = "de") {

  return {
    "query": APIQueries.chat.eddieCheck.query,
    "variables": { ...APIQueries.chat.eddieCheck.variables, ...  APIQueries.chat.roomIds[room]  }
  }
}

function SendMessagesQuery(room = "de", message) {

  return {
    "query": APIQueries.chat.sendMessage.query,
    "variables": { ...APIQueries.chat.sendMessage.variables, ...  APIQueries.chat.roomIds[room], ... {message}  }
  }
}

function formatHouseBet(data) {
  const reg = /(roll|bet)/gi
  const results = []

  if (!data)
    return []

  for (const [key, bet] of Object.entries(data)) {
    //console.log(`${key}:`, bet);

    let resObj = { id: bet.id, iid: bet.iid || undefined, game: bet.game, amount: bet.amount, currency: bet.currency, payout: bet.payout, payoutMultiplier: bet.payoutMultiplier, result: bet.state  }

    if (resObj.game == "limbo")
      resObj.result.result = Math.floor(resObj.result.result * 100) / 100
    else if (resObj.game == "diamonds")
      resObj.result.result = [...resObj.result.hand]
    else if (resObj.game == "scarabspin" || resObj.game == "tomeoflife" || resObj.game == "slots"){
    // let obj = [...resObj.result.rounds]
     resObj.result.result  =  [...resObj.result.rounds]
}
    results.push(resObj)
  }

  return (results.length == 1) ? results : results

}

/** changed from createBetWS to createBet temporarely */
async function createBetWs(config) {
  var formResult
  try {
    let result = await Client_gqlws.wsQuery(createBetQuery(config.game, config.variables))

    if (result.errors)
      return {error: result.errors, data: null}

      formResult = formatHouseBet(result.data)

      return {error: null, data: formResult[0]}

  }
  catch (err) {
    console.error("Error in createBetWs ", err)
  }

}
async function getActiveBet(game) {
  var formResult
  try {
    let result = await Client_gqlws.wsQuery(createActiveBetQuery(game))

    if (result.errors)
      return {error: result.errors, data: null}

      //formResult = formatHouseBet(result.data)
      if( result.data?.user?.activeCasinoBet)
        formResult = result.data?.user?.activeCasinoBet //formatHouseBet([result.data?.user?.activeCasinoBet])[0]; 

      return {error: null, data: formResult}

  }
  catch (err) {
    console.error("Error in createBetWs ", err)
  }

}

async function createBet(config) {
  var formResult
  try {
    let result = await postData(reqConfig.url, createBetQuery(config.game, config.variables), reqConfig)

    if (result.errors)
      return {error: result.errors, data: null}


    formResult = formatHouseBet(result.data)


    return {error: null, data: formResult[0]}

  }
  catch (err) {
    console.error("Error in createBet", err)
  }

}

async function betLookup(config) {
  try {

    let result = await postData(reqConfig.url, BetLookupByIdQuery(config.variables.bid), reqConfig)

    if (result.errors)
      return [result.errors, null]
    else if (result.data)
      return [null, result.data]

  }
  catch (err) {
    console.error("Error in betLookup fnc ", err)
  }
}


async function sendChatMessage(room = "de", message){
  
  try {
    let result = await Client_gqlws.wsQuery(SendMessagesQuery(room, message))

    if (result.errors)
      return [result.errors, null]

      return [null, result.data]

  }
  catch (err) {
    console.error("Error in sendMessage ", err)
  }
}

async function getCurrenciesInfos(){
  
  try {
    let result = await Client_gqlws.wsQuery(createCurrenciesInfoQuery())

    if (result.errors)
      return {error: result.errors, data: null}

      return {error: null, data: result.data.info}

  }
  catch (err) {
    console.error("Error in getCurrenciesInfos ", err)
  }
}


const  subscribeHouseBets = (game) => {
  if(!game || game.length == 0)
    return 

  console.log("subscribeHouseBets ", game)
  if(Client_gqlws.unsubscribeHouseBets)
    Client_gqlws.unsubscribeHouseBets()

    Client_gqlws.unsubscribeHouseBets = Client_gqlws.wsSubscribe(APIQueries.bets.houseBets[game], (bet) => {
     // console.log("subscription houseBets ", game)
      if(bet.data.houseBets.game.name.replace(" ","").toLowerCase() == game || (game == 'scarab' && bet.data.houseBets.game.name.toLowerCase() == "scarab spin")  || (game == 'tomeoflife' && bet.data.houseBets.game.name.toLowerCase() == "tome of life")  || (game == 'samurai' && bet.data.houseBets.game.name.toLowerCase() == "blue samurai"))
        Client_gqlws.emitter.emit("sub houseBets", bet.data.houseBets)

  });
}

const formatUserData = (data) => {
  let coins = [  "ape",  "bch",  "bnb",  "btc",   "cro",  "dai",   "doge",   "eos",   "eth",   "link",  "ltc",  "pol",  "sand", "shib",  "sol", "trx",    "uni",    "usdc",    "usdt",    "xrp", "gold", "sweeps"]
  let result = { id: data.id, name: data.name, balances: { }, vault: { } };
  data.balances
    .filter( v => { return coins.includes(v.available.currency.toLowerCase()) ? true : false })
    .forEach( el => {
       let key = el.available.currency
       result.balances[key] = el.available.amount
        result.vault[key] = el.vault.amount
    })
  return result
}
const createStakeWsClient = async (apikey) => { 
  if(Client_gqlws)
    Client_gqlws.dispose()

   Client_gqlws =  await _createStakeWsClient(apikey)
  
   Client_gqlws.on('connected', async () => {
   
    Client_gqlws.emitter.emit("gqlws connected")
    })


    // get basic user info
   const userData = await Client_gqlws.wsQuery(createUserDataQuery()) 

   if(userData.data.user !== null){
        console.log("createWsClient userData: ", userData)
        Client_gqlws.emitter.emit("logged in")

        User.set( formatUserData(userData.data.user))

        // subscribe to balance updates
        
        Client_gqlws.wsSubscribe(createUserBalancesQuery(), (res) => {
          User.updateBalances([res.data.availableBalances.balance])
        })

        /** test subscriptions */
        let _config = {
          query: ` subscription a{
              tips {
                transferId: id
                amount
                currency
                receivedBy: user { id name}
                sendBy { id name }
                isPublic
                transferDate: createdAt
              }
          }`,
          variables: {

          }

          /*  
          response
                   tips: {
                      "transferId": "a1adb632-8316-40e5-8021-c99f3c6c1c21",
                      "amount": 0.00000447,
                      "currency": "btc",
                      "receivedBy": {
                          "id": "ab1e2287-2d2a-4e6a-a982-c7f0c85551ee",
                          "name": "notYou"
                      },
                      "sendBy": {
                          "id": "01acb598-57eb-497a-a9f2-d7def77f78cb",
                          "name": "Dogecoinbrot"
                      },
                      "isPublic": false,
                      "transferDate": "Wed, 05 Jan 2022 20:05:01 GMT"
                  }
          */
        }

        Client_gqlws.wsSubscribe(_config, (res) => {
          console.log("[subscription] tips: ")
          console.log(res.data)
        })
      }
    else{
      console.log("createWsClient error: invalid api key")
      Client_gqlws.emitter.emit("invalid apikey")

    }


   Client_gqlws.emitter.on('sub houseBets', (data) => {
     let bet = { ... {...data.bet}, ...{game: data.game.name.replaceAll(" ","").toLowerCase().replace("bluesamurai","samurai"), iid: data.iid}}
     let formBet = formatHouseBet([bet])
     //let formBet = formatHouseBet(bet)

   
     //emit event with formatted data
     Client_gqlws.emitter.emit("houseBets", formBet)
   })
    return Client_gqlws
  }

const gqlwsInstance = () =>{
  return Client_gqlws
}

export { APIQueries, createBetQuery, createStageBetQuery, createMyBetListQuery,createUserDataQuery, getCurrenciesInfos, betLookup, formatHouseBet, createBet,ChatMessagesQuery, ChatEddieCheckQuery, createStakeWsClient, createBetWs, subscribeHouseBets, sendChatMessage, getActiveBet, gqlwsInstance}

/*
const arr = ["red", "blue", "green", "red", "blue"];
const result = arr.reduce((acc, curr, i) => ((!acc[curr]?.count) ? acc[curr] = { count: 0, pos: [] } : acc[curr], acc[curr].count = (acc[curr]?.count || 0) + 1, acc[curr].pos = [... (acc[curr]?.pos || []), ...[i]], acc), {});
console.log(result);


const arr = ["red","blue","green","red","blue"];
const result = arr.reduce((acc, curr,i) => ( (!acc[curr]?.count) ? acc[curr] = { count: 0, pos: []} : undefined , acc[curr].count = (acc[curr]?.count || 0) + 1, acc[curr].pos = [... (acc[curr]?.pos || []), ... [i]],  acc), {});
console.log(result);

{
  blue: {count: 2, pos: Array(2)}
  green: {count: 1, pos: Array(1)}
  red: {count: 2, pos: Array(2)}
}
*/